import { PageType } from '@/constants'
import type { FlashSaleModal } from '@/types'
import { useTranslations } from 'next-intl'
import Countdown from '../ProductCard/Countdown'
import ProgressBarV1 from '../ProgressBar/ProgressBarV1'
import OriginPrice from './OriginPrice'
import SalePrice from './SalePrice'

interface FlashSalePriceType {
  type?: string
  originPrice: number
  finalPrice: number
  flashSale: FlashSaleModal
  productId: string
  hasGift?: boolean
  priceAtWarehouse?: boolean
}

export const FlashSalePrice = ({
  originPrice,
  finalPrice,
  flashSale,
  productId,
  hasGift,
  priceAtWarehouse,
}: FlashSalePriceType) => {
  const t = useTranslations('ProductDetail')
  // const percent = Math.ceil(100 - (finalPrice / originPrice) * 100)
  return (
    <div className='wrapper flex w-full items-center justify-between overflow-hidden rounded bg-primary-second px-2 py-3'>
      <div className='price flex-50'>
        <p className='label text-white text-sm font-bold leading-6'>
          {priceAtWarehouse
            ? t('warehousePrice')
            : hasGift
            ? 'Giá online rẻ hơn'
            : t('priceWithShip')}
          :
        </p>

        <SalePrice
          finalPrice={finalPrice}
          classes={'!text-3xl font-bold leading-none text-white'}
          type={PageType.PRODUCT}
        />

        <div className='flex justify-start items-center gap-x-2'>
          <OriginPrice
            type={PageType.PRODUCT}
            originPrice={originPrice}
            classes='text-base text-white-400 leading-none line-through'
          />
          {/* {percent > 0 && (
            <span className='discount flex items-center gap-[2px]'>
              <span className='flex items-center text-percent bg-white rounded h-5 px-[2px] text-dark-900 text-sm font-normal'>
                <span className='value'>-{percent}</span>
                <span className='unit'>%</span>
              </span>
            </span>
          )} */}
        </div>
      </div>
      <div className='max-w-[146px] flex-50'>
        <div className='countdown relative'>
          <Countdown
            productId={productId}
            endTime={flashSale?.endTime}
            type={'product-detail'}
          />
        </div>
        <div className='countdown'>
          <ProgressBarV1 flashSale={flashSale} type={'product-detail'} />
        </div>
      </div>
    </div>
  )
}

export default FlashSalePrice
